import { SVG_LOGO } from '../logo'

export const headerBlock = (today, periodoDesde, periodoHasta) => `
  <div class="header">
    <div class="header-top">
      <div></div>
      <div class="logo">${SVG_LOGO}</div>
    </div>
    <div class="title">INFORME SINIESTRAL</div>
    <div class="header-bottom">
      <span>Fecha&nbsp;&nbsp;&nbsp;&nbsp;${today}</span>
      <span>Período: ${periodoDesde} - ${periodoHasta}</span>
    </div>
  </div>`

export const buildEmpleadorBlock = (empleador, reportData) => `
  <div class="info-box">
    <div class="rs">Razón social: ${empleador?.razonSocial ?? ''}</div>
    <div class="info-row">
      <span>C.U.I.T: ${empleador?.cuit ?? reportData?.cuit ?? ''}</span>
      <span class="mid">Contrato: ${empleador?.contrato ?? ''}</span>
    </div>
  </div>`

export const footerBlock = (current, total) => `
  <div class="footer">
    <div style="display:flex; flex-direction:column; align-items:flex-start; gap:2px;">
      <span style="font-size:9px; color:#999;">0326</span>
      <span style="font-size:9px; color:#fff; background:#3c3c3b; padding:2px 8px;">PV-01-F015</span>
    </div>
    <span>Página ${current} / ${total}</span>
  </div>`
